<template>
  <div class="AuftragOverview"  @click="toDetails()">
    <b-card
    class="clickable"
    :header="auftrag.format.name"
    header-tag="strong"
    :header-class="headerClass()"
    >
     <template #header>
        {{auftrag.format.name}}<span :class="iconClass()"></span>
      </template>
    <b-card-text>
   <div><strong v-if="hasRoles(['Admin','Disponent','Mitglied'])">{{auftrag.firma ? auftrag.firma.name : auftrag.firmaFormular}}</strong>
    <span class="text-muted float-right">{{auftrag.firstInvite|formatDate}}</span>
   </div>
    <div class="row">
    <div class="col-12 col-md-6">
    <div class="">{{sendungThema}}</div>
    <div>{{auftrag.datum}}</div>
    </div>
    <div class="col-12 col-md-6">
     <b-button-group class="d-none" vertical>
       <b-button size="sm" :href="`#/auftrag/${auftrag.id}`" class="m-2" variant="primary" data-toggle="tooltip" data-placement="top" title="zur Detailseite">
           Detailseite
        </b-button>
        <b-button pill v-for="(btn, idx) in auftrag.__actions" :key="idx" @click="actionFunc(btn, auftrag.id)" class="m-2" size="sm" :variant="btn.variant" data-toggle="tooltip" data-placement="top" :title="btn.description">
          {{btn|actionText}}
         </b-button>
     </b-button-group>
      <AngebotOverview ref="AngebotOverview" :angebote="auftrag.angebote" :auftrag="auftrag"/>
    </div>
    </div>

    </b-card-text>
     <b-form>
     <input id="file-input" ref="fileInput" @change="uploadFile(auftrag.id)" type="file" name="name" style="display: none;" />
     <input type="hidden" ref="actionName" />
     <b-button-group class="d-none">
       <b-button ref="detailButton" pill size="sm" :to="`auftrag/${auftrag.id}`" class="m-2" variant="primary" data-toggle="tooltip" data-placement="top" title="zur Detailseite">
           Detailseite
        </b-button>

      <b-button pill v-for="(btn, idx) in auftrag.__actions" :key="idx" @click="actionFunc(btn, auftrag.id)" class="m-2" size="sm" :variant="btn.variant" data-toggle="tooltip" data-placement="top" :title="btn.description">
        {{btn|actionText}}
       </b-button>
     </b-button-group>
    </b-form>
  </b-card>
  </div>
</template>
<script>
import api from '@/api/workflow'
import afunc from '@/functions'
import AngebotOverview from '@/components/partials/AngebotOverview'
import utils from '@/utilities'

export default {
  name: 'AuftragOverview',
  components: {AngebotOverview},
  props: ['auftrag'],
  data () {
    return {
      user: this.$store.state.auth.user,
      loading: false
    }
  },
  computed: {
    sendungThema: function () {
      return ((this.auftrag.kundeFormular + ' - ' || '') + this.auftrag.sendung || 'n.a.') + ' - ' + (this.auftrag.thema || 'n.a.')
    }
  },
  methods: {
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    },
    toDetails () {
      this.$router.push('auftrag/' + this.auftrag.id)
    },
    iconClass () {
      return utils.headerClass(this.user, this.auftrag, 'icon-status') + ' ' + afunc.findIconClass(this.user, this.auftrag)
    },
    uploadFile (id) {
      afunc.uploadFile(this, api, id)
    },
    actionFunc (action, id) {
      afunc.actionFunc(this, api, action, id, new FormData())
    },
    headerClass () {
      return utils.headerClass(this.user, this.auftrag, 'status')
    },
    refresh () {
      this.$emit('refresh-list')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/AuftragOverview.vue